import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import router from './router'
import { i18n, currentLocale } from './i18n'
import { installLocaleLinkSync } from './i18n/shared-locale'
import { LANDING_URL, LOGISTICS_URL } from './utils/config'
import './assets/main.css'

// Links to the landing page and the logistics app carry the language chosen here.
installLocaleLinkSync([LANDING_URL, LOGISTICS_URL], currentLocale)

const app = createApp(App)
const sentryDsn = import.meta.env.VITE_SENTRY_DSN?.trim()

if (sentryDsn) {
  Sentry.init({
    app,
    dsn: sentryDsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT?.trim() || import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE?.trim() || undefined,
  })
}

app.use(router).use(i18n).mount('#app')
